
import React, { useState, useEffect } from 'react';
import * as styles from "./PopupBrowserLanguage.module.scss";
import { RenderRichContent } from '../RenderRichContent/RenderRichContent';

const PopUpBrowserLanguage = ({ data }) => {
  const [show, setShow] = useState(true);
  const [isselected, setselected] = useState("");

  const [scroll, setScroll] = useState(false);
  const [isPopupChecked, setIsPopupChecked] = useState(false);

  
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 0);
    });

    const hasSeenPopup = sessionStorage.getItem('hasSeenPopup');

    if (hasSeenPopup) {
      setShow(false); // Show the popup
    }

    setIsPopupChecked(true);

    let userlanguage = typeof window !== "undefined" ? window.navigator.language : null;
    
    if (userlanguage === "nl") {
      setselected("nl");
    } else if (userlanguage === "en" || userlanguage === "en-US") {
      setselected("en");
    } else if (userlanguage === "de") {
      setselected("de");
    }
  }, []);

  let userlanguage = typeof window !== "undefined" ? window.navigator.language : null;

  const options = [
    {
      value: data[1].dropdownEnglish,
      language: "en"
    },
    {
      value: data[0].dropdownDutch,
      language: "nl"
    },
    {
      value: data[2].dropdownGerman,
      language: "de"
    }
  ];

  const onOptionChangeHandler = () => {
    if (isselected === "nl") {
      window.location.href = "https://edcontrols.nl/";
    } else if (isselected === "en") {
      window.location.href = "https://edcontrols.co.uk/";
    } else if (isselected === "de") {
      window.location.href = "https://edcontrols.de/";
    }

    // sessionStorage.setItem('hasSeenPopup', 'true');

  };

  const closePopup = () => {
    setShow(false);

    sessionStorage.setItem('hasSeenPopup', 'true');
  };

  if (!isPopupChecked) {
    return null;
  }

  return (
    <>
      {userlanguage !== process.env.language &&
        ((userlanguage === "en" && process.env.language !== "en-US") || 
        (userlanguage === "en-US" && process.env.language !== "en") || 
        userlanguage === "nl" || userlanguage === "de") && (
        <>
          {show && (
            <div className={`${styles.popupcontainer} flex h-[3.5rem] bg-[#e9ebed] justify-end pr-32 pt-5 ${
              scroll ? "lg:h-0 hidden" : "lg:h-[3.5rem]"
            } font-sans`}>

              {userlanguage === "en" && 
           <RenderRichContent content={data[1].popUpText} classNames='pr-7 text-[14px]' role={undefined} />
        }
         {userlanguage === "nl" && 
           <RenderRichContent content={data[0].popUpText} classNames='pr-7 text-[14px]' role={undefined} />
        }
         {(userlanguage === "de") && 
           <RenderRichContent content={data[2].popUpText} classNames='pr-7 text-[14px]' role={undefined} />
        }
         {(userlanguage === "en-US") && 
           <RenderRichContent content={data[3].popUpText} classNames='pr-7 text-[14px]' role={undefined} />
        }
              <select
                onChange={e => setselected(e.target.value)}
                value={isselected}
                className="w-[142.3px] rounded mb-3 mr-2 text-[14px] pl-2 font-sans"
              >
                {options.map((option, index) => (
                  <option key={index} value={option.language}>
                    {option.value}
                  </option>
                ))}
              </select>

              <button
                type="submit"
                className="border border-[#303d4e] w-[50px] text-[13px] text-[#303d4e] font-bold bg-[white] rounded h-auto mb-3"
                onClick={onOptionChangeHandler}
              >
                OK
              </button>
              <button
                className="ml-2 rounded-full px-2 pb-5 cursor-pointer"
                onClick={closePopup}
              >
                x
              </button>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default PopUpBrowserLanguage;